import { api } from './axios-client.js';
// Auth API
export const authApi = {
    captcha: () => api.get('/v1/auth/verifycode'),
    login: (data) => api.post('/v1/auth/login', data),
    logout: () => api.post('/v1/auth/logout'),
    me: () => api.get('/v1/me'),
};
//# sourceMappingURL=auth-api.js.map